import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
}

const VARIANT_CLASSES: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary: "bg-accent-600 text-white hover:bg-accent-700 active:bg-accent-700",
  secondary: "bg-ink-50 text-ink-800 hover:bg-ink-100 active:bg-ink-100 border border-ink-200",
  ghost: "text-ink-600 hover:bg-ink-50 active:bg-ink-100",
};

export function Button({ variant = "secondary", className = "", children, ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      className={`inline-flex min-h-[40px] items-center justify-center gap-2 rounded-lg px-3.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${VARIANT_CLASSES[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
